export default "__VITE_ASSET__DYpOhUXE__"